import { Form } from 'factorial-form'
import {
  ProfileEmployeeResourceFieldDataFragment,
  ValueDataFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { coerceValueFromType } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/coerceValueFromType'
import { getValueType } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/getValueType'

export const createForm = (
  customResourceField: ProfileEmployeeResourceFieldDataFragment,
  customValue: ValueDataFragment | undefined
) => {
  const { field: customField, id: resourceFieldId } = customResourceField

  // NOTE: consider making this non-optional in the resource registry so this cannot be null.
  if (!customField) {
    throw new Error('Custom field not found')
  }

  const withNullLabel =
    customField.fieldType === 'date' ? i18n.t('settings.custom_fields.remove_date') : ''

  const options = customField.options ?? []

  const values = {
    choice_options: options,
    editable: customField.editable,
    field_id: customField.id,
    field_type: customField.fieldType,
    mandatory: customField.required,
    max_value: customField.maxValue,
    min_value: customField.minValue,
    name: customField.labelText,
    options,
    value_id: customValue?.id,
    value: customValue ? coerceValueFromType(customValue, customField.fieldType) : null,
    visible: null,
    withNullLabel,
    resource_field_id: resourceFieldId,
  }

  const form = new Form(values, {
    choice_options: 'string',
    editable: 'boolean',
    field_id: 'number',
    field_type: 'string',
    installed: 'boolean',
    mandatory: 'boolean',
    max_value: 'number',
    min_value: 'number',
    name: 'string',
    options: 'string',
    value_id: 'number',
    value: getValueType(customField.fieldType),
    visible: 'any',
    withNullLabel: 'string',
    resource_field_id: 'number',
  })

  return form
}
